import { Table } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import React from 'react';
import useBaseTableProps from '../../../hooks/useBaseTableProps';

const RentForecastTable = (props) => {
  const {
    allColumnsHidden,
    columnOptions,
    count,
    currentRentForecast,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    footerRow,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    handleSettingsClose,
    headers,
    height,
    intl,
    name,
    onCSVButtonClick,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    toolbarActions,
    totalCount,
    isLoading,
    rightToolbarActions,
  } = props;
  const baseTableProps = useBaseTableProps();

  return (
    <Table
      {...baseTableProps}
      allColumnsHidden={allColumnsHidden}
      columnOptions={columnOptions}
      count={count}
      dateState={dateState}
      emptyStateMessage={
        !currentRentForecast ? 'Create a Rent Forecast' : undefined
      }
      filterState={filterState}
      filterTypeState={filterTypeState}
      filteredHeaders={filteredHeaders}
      footerRow={footerRow}
      handleColumnChange={handleColumnChange}
      handleDateSubmit={handleDateSubmit}
      handleFilterChange={handleFilterChange}
      handleFilterTypeChange={handleFilterTypeChange}
      handleSearchSubmit={handleSearchSubmit}
      handleSortChange={handleSortChange}
      handleSettingsClose={handleSettingsClose}
      headers={headers}
      height={height}
      intl={intl}
      name={name}
      onCSVButtonClick={onCSVButtonClick}
      order={order}
      orderBy={orderBy}
      rows={rows}
      searchState={searchState}
      selectedColumns={selectedColumns}
      toolbarActions={toolbarActions}
      rightToolbarActions={rightToolbarActions}
      totalCount={totalCount}
      isLoading={isLoading}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    />
  );
};

export default RentForecastTable;
